// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7fe74db6c42be2e09aa3","655":"478502ed9ea3638a73ef"}[chunkId] + ".js";
};